import React from "react";
import { StyledTypography } from "./StyledTypography";
import { useTitle } from "./useTitle";

export const Title: React.FC = () => {
  const title = useTitle();
  return (
    <StyledTypography variant="body2" component="h1" color="textSecondary" gutterBottom={true}>
      {title}
    </StyledTypography>
  );
};
